import { IModel } from '@/@types/models/model';
import coreFields from '../helpers/coreFields';
import commonFields from '../helpers/commonFields';

// this model is useless right?
const GMUkopani: IModel = {
  title: 'GMUkopani',
  apiPath: 'groblja/grobna-mjesta/{grobno_mjesto_id}/ukopani',
  forms: {
    default: {
      fields: [
        'groblje_id',
        'grobno_mjesto_id',
        'registar_umrlih_id',
        'redni_broj',
        'datum_ukopa',
        'datum_ekshumacije',
        'mjesto_ekshumacije',
        'pogrebnik_preuzeo',
        'znamenita_povijesna_osoba',
        'hrv_branitelj_iz_dom_rata_bez_nasljednika',
        'lokalno_znacajna_osoba',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
      ],
      layout: [
        {
          title: 'groblja:sections.podaci_o_ukopu',
          columns: 2,
          fieldNames: ['groblje_id', 'grobno_mjesto_id', 'registar_umrlih_id', 'redni_broj', 'datum_ukopa'],
        },
        {
          title: 'groblja:sections.status',
          columns: 3,
          fieldNames: ['znamenita_povijesna_osoba', 'hrv_branitelj_iz_dom_rata_bez_nasljednika', 'lokalno_znacajna_osoba'],
        },
        {
          title: 'groblja:sections.knjiga_ocevidnika',
          columns: 3,
          fieldNames: ['ocevidnik_knjiga_broj', 'ocevidnik_knjiga_strana', 'ocevidnik_knjiga_redni_broj'],
        },
        {
          title: 'groblja:sections.pomocna_knjiga',
          columns: 3,
          fieldNames: ['ocevidnik_pomocna_knjiga_broj', 'ocevidnik_pomocna_knjiga_strana', 'ocevidnik_pomocna_knjiga_redni_broj'],
        },
        {
          title: 'groblja:sections.ekshumacija',
          columns: 3,
          fieldNames: ['datum_ekshumacije', 'mjesto_ekshumacije', 'pogrebnik_preuzeo'],
        },
        {
          title: 'common.ostalo',
          columns: 1,
          fieldNames: ['napomena'],
        },
      ],
    },
  },
  listViews: {
    default: {
      fields: [
        'id',
        'oib',
        'ime',
        'prezime',
        'datum_rodenja',
        'datum_smrti',
        'redni_broj',
        'datum_ukopa',
        'datum_ekshumacije',
        'mjesto_ekshumacije',
        'pogrebnik_preuzeo',
        'znamenita_povijesna_osoba',
        'hrv_branitelj_iz_dom_rata_bez_nasljednika',
        'lokalno_znacajna_osoba',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
        'napomena',
        'docs',
      ],
      hidden: [
        'id',
        'ocevidnik_knjiga_broj',
        'ocevidnik_knjiga_strana',
        'ocevidnik_knjiga_redni_broj',
        'ocevidnik_pomocna_knjiga_broj',
        'ocevidnik_pomocna_knjiga_strana',
        'ocevidnik_pomocna_knjiga_redni_broj',
      ],
    },
  },
  fields: [
    coreFields.id,
    {
      title: 'grobno_mjesto_id',
      source: 'grobno_mjesto_id',
      ttoken: 'groblja:grobna_mjesta.grobno_mjesto',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/grobna-mjesta?view=picker',
        format: '{label}',
        idattr: 'id',
        additionalData: ['groblje_id'],
      },
      validation: {
        required: true,
      },
    },
    {
      type: 'boolean',
      source: 'has_history',
      title: 'has history',
      ttoken: 'common.has_history',
    },
    {
      title: 'registar_umrlih_id',
      source: 'registar_umrlih_id',
      ttoken: 'groblja:ukopani.registar_umrlih_neukopani',
      type: 'picker',
      subModel: {
        apiPath: 'groblja/registar-umrlih?view=picker_neukopani',
        idattr: 'id',
        format: '{label}',
        additionalData: ['groblje_id'],
      },
      filter: true,
      validation: {
        required: true,
      },
    },
    {
      title: 'groblje_id',
      source: 'groblje_id',
      ttoken: 'groblja:grobna_mjesta.groblje',
      type: 'picker',
      subModel: {
        apiPath: 'groblja?view=picker',
        format: '{label}',
        idattr: 'id',
      },
      validation: {
        required: true,
      },
      filter: true,
    },
    {
      title: 'oib',
      source: 'oib',
      ttoken: 'groblja:registar_umrlih.oib',
      type: 'text',
      filter: true,
    },
    {
      title: 'ime',
      source: 'ime',
      ttoken: 'common.ime',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime',
      source: 'prezime',
      ttoken: 'common.prezime',
      type: 'text',
      filter: true,
    },
    {
      title: 'prezime_ime',
      source: 'prezime_ime',
      ttoken: 'groblja:registar_umrlih.prezime_ime',
      type: 'text',
      filter: true,
    },
    {
      title: 'redni_broj',
      source: 'redni_broj',
      ttoken: 'groblja:ukopani.redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },

    {
      title: 'datum_ukopa',
      source: 'datum_ukopa',
      ttoken: 'groblja:ukopani.datum_ukopa',
      type: 'date',
      filter: true,
    },

    {
      title: 'datum_ekshumacije',
      source: 'datum_ekshumacije',
      ttoken: 'groblja:ukopani.datum_ekshumacije',
      type: 'date',
      filter: true,
    },

    {
      title: 'mjesto_ekshumacije',
      source: 'mjesto_ekshumacije',
      ttoken: 'groblja:ukopani.mjesto_ekshumacije',
      type: 'text',
      filter: true,
    },

    {
      title: 'pogrebnik_preuzeo',
      source: 'pogrebnik_preuzeo',
      ttoken: 'groblja:ukopani.pogrebnik_preuzeo',
      type: 'text',
      filter: true,
    },

    {
      title: 'znamenita_povijesna_osoba',
      source: 'znamenita_povijesna_osoba',
      ttoken: 'groblja:ukopani.znamenita_povijesna_osoba',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
    },

    {
      title: 'hrv_branitelj_iz_dom_rata_bez_nasljednika',
      source: 'hrv_branitelj_iz_dom_rata_bez_nasljednika',
      ttoken: 'groblja:ukopani.branitelj_bez_nasljednika',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
    },

    {
      title: 'lokalno_znacajna_osoba',
      source: 'lokalno_znacajna_osoba',
      ttoken: 'groblja:ukopani.lokalno_znacajna_osoba',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_broj',
      source: 'ocevidnik_knjiga_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_strana',
      source: 'ocevidnik_knjiga_strana',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_knjiga_redni_broj',
      source: 'ocevidnik_knjiga_redni_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_knjiga_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_broj',
      source: 'ocevidnik_pomocna_knjiga_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_strana',
      source: 'ocevidnik_pomocna_knjiga_strana',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_strana',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'ocevidnik_pomocna_knjiga_redni_broj',
      source: 'ocevidnik_pomocna_knjiga_redni_broj',
      ttoken: 'groblja:grobna_mjesta.ocevidnik_pomocna_knjiga_redni_broj',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'napomena',
      source: 'napomena',
      ttoken: 'common.napomena',
      type: 'multiline',
      rows: 3,
      maxRows: 10,
      width: 'full',
      filter: true,
    },
    {
      title: 'is_deleted',
      source: 'is_deleted',
      ttoken: '',
      type: 'boolean',
      items: {
        labels: ['common.no', 'common.yes'],
        values: [false, true],
        default: false,
      },
      filter: true,
      readonly: true,
    },
    {
      title: 'edited',
      source: 'edited',
      ttoken: 'common.edited',
      type: 'datetime',
      filter: true,
    },
    {
      title: 'action',
      source: 'action',
      ttoken: 'common.action',
      type: 'picker',
      items: {
        labels: ['common.actions.update', 'common.actions.insert', 'common.actions.delete'],
        values: ['UPDATE', 'INSERT', 'DELETE'],
      },
      filter: true,
      translate: true,
      readonly: true,
    },
    {
      title: 'datum_smrti',
      source: 'datum_smrti',
      ttoken: 'groblja:ukopani.datum_smrti',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    {
      title: 'datum_rodenja',
      source: 'datum_rodenja',
      ttoken: 'groblja:ukopani.datum_rodenja',
      type: 'numeric',
      filterType: 'text',
      filter: true,
    },
    coreFields.created_by,
    coreFields.created_on,
    coreFields.modified_by,
    coreFields.modified_on,
    commonFields.docsHistory,
  ],
};

export default GMUkopani;
